export default __webpack_public_path__ + "static/media/BOGGLE.7f37ec89.jpg";